import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from "../../nest-api";
import { RequestFamilyDto } from '../dto/family.dto';

@Injectable()
export class FamilyNestApi {

  private service: string = '';
  private model: string = 'Familydependents';

  constructor(
    public nestApiProvider: NestApiProvider,
  ) {
  }

  public getFamilyDependent(payload: RequestFamilyDto): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getFamilyDependent';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/family.api.ts